@if (showSpinner) {
  <app-loader></app-loader>
}
<main class="content-wrapper" [ngStyle]="{ background: selectedMode === 'dark' ? '#111526' : '' }">
  <div class="header-wrapper">
    <div class="row button-row ml-1 mr-1 justify-content-between text-left"
      [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
      <div class="col-sm-6 mt-3 mt-sm-0">
        <h1 class="main-header-heading">Select Evaluation Month</h1>
      </div>
      <div class="col-sm-5 p-0">
        <div class="d-flex justify-content-end">
          <div class="col-sm-7 mt-3 mt-sm-0">
            <input type="date" placeholder="Select Month" name="salary_month" id="salary_month"
              class="date-type form-control inputbtn" [(ngModel)]="selectedDate" (ngModelChange)="onDateChange($event)"
              required />
            </div>
            <!-- <div class="col-sm-5 mt-3 mt-sm-0  ">
            <button  type="submit "
            class="btn btn-primary
          apply show-salary">
              Show Monthly Salary
            </button>
          </div> -->
        </div>
      </div>
    </div>
  </div>
  <div class="body-wrapper">
    <div class="tabbs-main-wrraper">


      <ul id="myTabs" class="nav nav-pills nav-justified" role="tablist" data-tabs="tabs"
        [ngClass]="{ 'dark-ul': selectedMode === 'dark' }">

        @for (role of office_roles_array; track role) {
          @if ((user_role === 'Admin' && role.role_names.toLowerCase() !== 'open') ||
            (role.role_names === 'Dev' && (user_role === 'Team_Lead' || user_role === 'Admin_AND_Team_Lead'))) {
            <li class="nav-item"
              >
              <a class="nav-link" [class.active]="role.id === activeRoleId" href="javascript:void(0)"
                (click)="setActiveRole(role.id)">
                {{ role.role_names }}
              </a>
            </li>
          }
        }
      </ul>
    </div>
    <div class="main-body-heading" [ngClass]="{ 'dark-body-heading': selectedMode === 'dark' }">
      <h1>Evaluation of Month</h1>
    </div>

    <div class="tabs-mainbody-wrraper">
      <div class="tab-content">
        <!-- tab-1 Dev -->

        <div class="secondaryContainer">
          <table>
            <thead>
              <tr class="headerBackground" [ngClass]="{ 'dark-headerBackground': selectedMode === 'dark' }">
                <th>User Name</th>
                <th>Role</th>
                @for (type of kps_points; track type) {
                  <th style="max-width: 137px">
                    <div class="heading-main">
                      {{ type.title }}
                      <span>{{ type.value }}</span>
                    </div>
                  </th>
                }
              </tr>
            </thead>
            <tbody>
              @for (user of users; track user) {
                <tr [ngClass]="{ 'dark-headerBackground': selectedMode === 'dark' }">
                  <td class="user-name">
                    <h1></h1>
                  </td>
                  <td class="user-role">TL @if (user_role !== 'Admin' && (user_role === 'Team_Lead' || user_role === 'Admin_AND_Team_Lead')) {
                    <span
                      >{{
                    calculateTLTotalPoints(user.user.id) }}</span>
                  }</td>
                  @if (user_role === 'Admin' && user_role !== 'Team_Lead') {
                    @for (point of kps_points; track point; let i = $index) {
                      <td>
                        <div class="form-group">
                          <div class="last-value">
                            {{
                            user.evaluations.length > 0 &&
                            user.evaluations[0].kps_value
                            ? user.evaluations[0].kps_value.split(",")[i]
                            : "0"
                            }}
                          </div>
                        </div>
                      </td>
                    }
                  }
                  @if (user_role !== 'Admin' && (user_role === 'Team_Lead' || user_role === 'Admin_AND_Team_Lead')) {
                    @for (point of kps_points; track point; let i = $index) {
                      <td>
                        <div class="form-group">
                          <input [(ngModel)]="inputValues[user.user.id].kps_value[i]"
                            (ngModelChange)="onInputChange(user.user.id, i, $event, point.value)"
                            [placeholder]="'Enter Value'" />
                            @if (errors && errors[user.user.id]) {
                              @if (errors[user.user.id][i]) {
                                <span class="text-danger">
                                  Your value is Greater {{ point.value }}
                                </span>
                              }
                            }
                          </div>
                        </td>
                      }
                    }
                  </tr>
                  <tr [ngClass]="{ 'dark-headerBackground': selectedMode === 'dark' }">
                    <td class="user-name border-bottom">
                      <h1>{{ user.user.first_name }} {{user.user.last_name }}</h1>
                    </td>
                    <td class="user-role">Admin @if (user_role === 'Admin' && user_role !== 'Team_Lead') {
                      <span> {{
                      calculateAdminTotalPoints(user.user.id) }}</span>
                    } </td>
                    @if (user_role !== 'Admin' && (user_role === 'Team_Lead' || user_role === 'Admin_AND_Team_Lead')) {
                      @for (point of kps_points; track point; let i = $index) {
                        <td>
                          <div class="last-value">
                            {{
                            user.evaluations.length > 0 &&
                            user.evaluations[0].pm_values
                            ? user.evaluations[0].pm_values.split(",")[i]
                            : "0"
                            }}
                          </div>
                        </td>
                      }
                    }
                    @if (user_role === 'Admin' && user_role !== 'Team_Lead') {
                      @for (point of kps_points; track point; let i = $index) {
                        <td>
                          <div class="form-group">
                            <input [(ngModel)]="inputValues[user.user.id].pm_values[i]"
                              (ngModelChange)="onInputChange(user.user.id, i, $event, point.value)"
                              [placeholder]="'Enter Value'" />
                              @if (errors && errors[user.user.id]) {
                                @if (errors[user.user.id][i]) {
                                  <span class="text-danger">
                                    Your value is Greater {{ point.value }}
                                  </span>
                                }
                              }
                            </div>
                          </td>
                        }
                      }
                    </tr>
                  }
                </tbody>
              </table>
            </div>




          </div>
        </div>
      </div>

      <div class="users-evaluation-table">
        <div class="buttons-section">
          <div class="btn btn-primary" (click)="goBack()">Back</div>
          <div class="btn btn-success" (click)="sendData()">Save</div>
        </div>
      </div>
    </main>